import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/nuri-design.css";
import "leaflet/dist/leaflet.css";
import App from "@/App";
import { initNativeFeatures } from "@/utils/native";
import { registerServiceWorker } from "@/utils/offlineSync";

initNativeFeatures();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
